module.exports = __webpack_public_path__ + "fonts/fa-solid-900.ada6e6df.woff2";